import { configurators, products, extras, upsells, testimonials, orders } from '@/agent';

const actions = {
  /**
   * Fetches configurator data based on the UID (e.g. 'bremen') from the Backend.
   * @param {*} param0
   * @param {*} param1
   */
  async fetchConfiguratorData({ commit }, { configuratorUID }) {
    const configuratorData = await configurators.get(configuratorUID);
    commit('setConfigurator', { configuratorData });
  },

  /**
   * Invokes agent method to retrieve all products assigned to a specific configurator and sets data
   * to store.
   * @param {Object} vuexMethods - all vuex methods
   * @param {String} configuratorId
   */
  async fetchProducts({ commit }, { configuratorId }) {
    const filteredProducts = await products.findByConfiguratorId(configuratorId);
    commit('setProducts', { products: filteredProducts });
  },

  async fetchExtras({ commit }, { productId }) {
    const filteredExtras = await extras.findByProductId(productId);
    commit('setExtras', { extras: filteredExtras });
  },

  async fetchUpsells({ commit }, { productId }) {
    const filteredUpsells = await upsells.findByProductId(productId);
    commit('setUpsells', { upsells: filteredUpsells });
  },

  async fetchTestimonials({ commit }) {
    const allTestimonials = await testimonials.all();
    commit('setTestimonials', { testimonials: allTestimonials });
  },

  /**
   *
   * @param {*} param0
   * @param {*} param1
   */
  setSelectedProduct({ commit }, { productId }) {
    commit('addProductToOrder', { productId });
  },

  /**
   *
   * @param {*} param0
   * @param {*} param1
   */
  setSelectedExtras({ commit }, { selectedExtras }) {
    commit('addExtrasToOrder', { selectedExtras });
  },

  removeSelectedExtras({ commit }) {
    commit('removeAllExtrasFromOrder');
  },

  /**
   *
   * @param {*} param0
   * @param {*} param1
   */
  setSelectedUpsells({ commit }, { selectedUpsells }) {
    commit('addUpsellsToOrder', { selectedUpsells });
  },

  removeSelectedUpsells({ commit }) {
    commit('removeAllUpsellsFromOrder');
  },

  setOrderDetails({ commit }, { formData }) {
    commit('addDetailsToOrder', { formData });
  },

  async postOrder(
    { commit },
    { configuratorId, details, selectedProduct, selectedExtras, selectedUpsells, orderValue },
  ) {
    await orders.post({
      configurator: configuratorId,
      // personal data
      businessCustomer: details.businessCustomer,
      FirstName: details.firstName,
      LastName: details.lastName,
      EmailAdress: details.emailAdress,
      PhoneNumber: details.phoneNumber,
      Company: details.company,
      Street: details.street,
      ZipCode: details.zipCode,
      City: details.city,
      PersonalMessage: details.personalMessage,
      AgbConfirmation: details.agbConfirmation,
      DSGVO: details.dsgvo,
      // is this order a request?
      Request: details.isRequest,
      // tour & order data
      PeopleCount: details.peopleCount,
      PlayDateTime: new Date(
        `${details.playDate} ${details.playTime}`.replace(/-/g, '/').replace('T', ' '),
      ).toISOString(),
      // Order value
      OrderValue: orderValue,
      // selected Products
      product: selectedProduct.replace('ST-', ''),
      extras: selectedExtras.map(item => Number(item.replace('ST-', ''))),
      upsells: selectedUpsells.map(item => Number(item.replace('ST-', ''))),
    });
    commit('addDetailsToOrder', {});
  },
};

export { actions as default };
